import { render, staticRenderFns } from "./lahanUmumMonitoring.vue?vue&type=template&id=9570708c"
import script from "./lahanUmumMonitoring.vue?vue&type=script&lang=js"
export * from "./lahanUmumMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports